import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section 
      id="home" 
      className="hero-hyper scroll-snap-section"
      style={{
        backgroundImage: "url('/fondo.jpg')",
        minHeight: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        marginTop: '80px', // Deja espacio para el navbar arriba
        paddingTop: '80px', // Deja espacio para el navbar arriba
      }}
    >
      <div className="hero-content-hyper">
        <h1 className="hero-title-hyper">
          Tu auto puede darte más que un alquiler
        </h1>
        <p className='hero-text-hyper'>Conectamos vehículos con conductores que lo necesitan</p>   
        <br />
        <div className="d-flex flex-column flex-md-row gap-3 mt-3">
          <a
            href="https://wa.me/5491172003387"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-hyper-primary"
          >Estoy listo para Arrank!</a>
          <a
            href="https://wa.me/5491168653099"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-hyper-primary"
          >¡Quiero manejar!</a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
